import React, { cloneElement } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { ROUTES } from 'consts'
import { notification } from 'antd'
import jwt_decode from 'jwt-decode'

/**
 *
 * @param {Object} props
 * @param {Array<String>} props.permissions
 * @param {React.ReactChildren} props.children
 */
const Authentication = ({ permissions, title, children, ...props }) => {
  const history = useHistory()
  const payload =
    localStorage.getItem('accessToken') && jwt_decode(localStorage.getItem('accessToken'))

  //modify title
  document.title = title

  //check login ?
  if (!payload) {
    return <Redirect to={ROUTES.LOGIN} />
  }

  return cloneElement(children, props)
}

export default Authentication
